import { useNavigate } from "react-router-dom";
import { jwtDecode as jwt_decode } from "jwt-decode";


export function useLogout() {
  const navigate = useNavigate();

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("userData");
    localStorage.removeItem("IAP");
    localStorage.removeItem("clientClassName");
    navigate("/login");
  }

  return logout;
}

export function isLoggedIn() {
  return Boolean(localStorage.getItem("token"));
}

export function isTokenExpired(token) {
  try {
    if (!token){
      return true
    }
    const { exp } = jwt_decode(token);
    if (!exp) return true;
    const now = Date.now() / 1000;
    const buffer = 15 * 60;
    return exp < now + buffer;
  } catch (e) {
    console.error("Error decoding token:", e);
    return true;
  }
}